/**
 *
 * Campaigns/Campaign/Form/AdditionalQuestions
 *
 */

import React from 'react'

// NPM Libraries
import 'tippy.js/dist/tippy.css'
import PropTypes from 'prop-types'
import FloatingLabel from '@joeyparis/react-floating-label-input'

// Components
import Checkbox from 'components/Checkbox'
import DragAndDropListSingleInput from 'components/DragAndDropList'

import { BlockedMessage } from 'components/Organizations/Index'

function CampaignFormAdditionalQuestions({ campaign_state, organization, setCampaignState, disabled }) {
	return (
		<div className="mt-2 row form-group">
			{!organization?.hide_user_campaign_additional_questions && (
				<div className="col">
					<div className="form-text text-muted d-flex">
						<span>Additional Questions</span>

						{campaign_state.questions?.filter((q) => q.length > 0)?.length > 0 && (
							<Checkbox
								label="Required?"
								checked={campaign_state.questions_required}
								onChange={() =>
									setCampaignState({
										questions_required: !campaign_state.questions_required,
									})
								}
								className="ml-5"
								disabled={organization?.default_campaign_questions_required}
							/>
						)}
					</div>

					<DragAndDropListSingleInput
						items={campaign_state.questions || []}
						blocked_items={organization?.questions}
						setItems={(questions) => setCampaignState({ questions })}
						placeholder="Start typing..."
						disabled={disabled}
					/>
				</div>
			)}

			{organization?.questions?.length > 0 && (
				<div className="col">
					<div className="form-text text-muted">
						<span>Organization Additional Questions</span>

						<BlockedMessage
							override_message={
								<React.Fragment>
									<b>Additional Question(s)</b> are Standardized at the Organization Level.
								</React.Fragment>
							}
							organization_name={organization.name}
						/>

						{organization?.questions?.map(({ question, options }, i) => (
							<div key={i}>
								<FloatingLabel type="text" value={question} disabled />
								{options.length > 0 && (
									<div className="ml-4 mb-3 mt-2">
										<span>Question Responses Options</span>
										{options.map((option, opt_i) => (
											<FloatingLabel key={opt_i} type="text" value={option} disabled />
										))}
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	)
}

CampaignFormAdditionalQuestions.propTypes = {
	campaign_state: PropTypes.object,
	organization: PropTypes.object,
	disabled: PropTypes.bool,
	setCampaignState: PropTypes.func,
}

export default CampaignFormAdditionalQuestions
